import { Stack } from "@mui/material";
import AssociateTraderToAffiliate from "../../components/admin/AssociateTraderToAffiliate";
import MakeAffiliate from "../../components/admin/MakeAffilaite";
import MakeTrader from "../../components/admin/MakeTrader";
import { useAuth } from "../../providers/AuthenticationProvider";
import MakeAffiliateMaster from "../../components/admin/MakeAffilaiteMaster";
import AddAnalysis from "../../components/admin/addAnalysis";
export const AdminPage = () => {
	const { profile } = useAuth();
	return (
		<>
			<Stack
				spacing={2}
				sx={{ maxWidth: 440, margin: "auto", display: "block" }}
			>
				<p>Hello ADMIN</p>
				<div>UID: {profile?.uid}</div>
				<MakeTrader />
				<MakeAffiliate />
				<MakeAffiliateMaster />
				<AssociateTraderToAffiliate />
				<AddAnalysis />
			</Stack>
		</>
	);
};
